export function getTargetPlayer(search: string): { id: string; name: string } | null {
  const params = new URLSearchParams(search);
  const id = params.get('targetSessionId')?.trim() || '';
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id)) {
    return null;
  }
  return { id, name: params.get('targetName')?.trim() || id };
}
